import { HHChip } from '@hinge-health/react-component-library';
import { Box, Skeleton } from '@mui/material';
import { ResolveStatus } from '../../context/types';
import {
  chipResolveKeyframes,
  MOTION_DURATION,
  MOTION_EASING,
  usePrefersReducedMotion,
} from '../motion/motion';

type ChipColor = 'success' | 'info' | 'error' | 'warning' | 'default';

const STATUS_COLOR: Record<ResolveStatus, ChipColor> = {
  pending: 'default',
  existing: 'success',
  new: 'info',
  conflict: 'error',
  error: 'warning',
};

const STATUS_LABEL: Record<ResolveStatus, string> = {
  pending: 'Resolving…',
  existing: 'Existing',
  new: 'New',
  conflict: 'Conflict',
  error: 'Failed',
};

interface StatusBadgeProps {
  status: ResolveStatus;
}

export const StatusBadge = ({ status }: StatusBadgeProps): JSX.Element => {
  const reduced = usePrefersReducedMotion();

  if (status === 'pending') {
    return <Skeleton variant="circular" width={84} height={24} />;
  }
  // The skeleton → chip swap is a fresh mount, so the keyframe fires exactly
  // once when the entity resolves — a small scale-in that reads as "settled".
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        animation: reduced
          ? 'none'
          : `${chipResolveKeyframes} ${MOTION_DURATION.state}ms ${MOTION_EASING.standard} both`,
      }}
    >
      <HHChip
        hhVariant="variant-bypass"
        size="small"
        color={STATUS_COLOR[status]}
        label={STATUS_LABEL[status]}
      />
    </Box>
  );
};
